<div class="auth-card animate__animated animate__fadeIn">
  <div class="auth-card-header">
    <h2>Recuperar Contraseña</h2>
    <p class="subtitle">Ingresá tu email para recibir instrucciones</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="resetPassword()" class="auth-form">
    <div class="form-group">
      <label>Email</label>
      <div class="input-wrapper">
        <i class="fas fa-envelope input-icon"></i>
        <input
          formControlName="email"
          type="email"
          class="form-control"
          placeholder="tu@email.com"
          [class.is-invalid]="emailNoValido"
        />
      </div>
      <small *ngIf="emailNoValido" class="error-msg">Ingrese un correo electrónico válido</small>
    </div>

    <div class="recaptcha-container">
      <ngx-recaptcha2
        #captchaElem
        [siteKey]="siteKey"
        formControlName="recaptcha"
      >
      </ngx-recaptcha2>
    </div>

    <button type="submit" class="btn-primary mt-4" [disabled]="!form.valid">
      Recuperar contraseña
    </button>

    <div class="auth-footer">
      <p><a routerLink="/login" class="link-highlight"><i class="fas fa-arrow-left"></i> Volver al login</a></p>
    </div>
  </form>
</div>
